import { jsx as a, jsxs as s } from "react/jsx-runtime";
import { Link as c } from "react-router-dom";
import "./main.scss";
import { conditionalString as o } from "@strata/helper-functions";
import * as h from "yup";
const k = ({
  linkText: n = "Default Label",
  navUrl: t,
  openInNewTab: r = !0
}) => /* @__PURE__ */ a(c, { className: "sds_hyperlink", to: t, target: r ? "_blank" : void 0, children: n }), v = ({ linkText: n, emailAddress: t, subject: r }) => {
  try {
    const e = h.string().email().required().validateSync(t);
    return /* @__PURE__ */ a(
      "a",
      {
        className: "sds_hyperlink",
        href: `mailto:${t}${o(!!r, `?subject=${r}`)}`,
        target: "_blank",
        rel: "noreferrer",
        children: n ?? e
      }
    );
  } catch {
    return n ? /* @__PURE__ */ a("span", { children: n }) : null;
  }
}, $ = (n) => {
  if (n == null)
    return;
  const t = /\[(?<text>(?:[^[\]\n])+)]\((?<url>https?:\/\/(?:[^()[\]\s])+)\)/gm, r = [...n.matchAll(t)];
  return r.length === 0 ? n : r.map(({ 0: e, groups: l, index: m }, i) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ s("span", { children: [
      i === 0 && n.substring(0, m),
      /* @__PURE__ */ a(k, { linkText: l == null ? void 0 : l.text, navUrl: (l == null ? void 0 : l.url) ?? "" }),
      r[i + 1] != null ? n.substring(
        (m ?? 0) + e.length,
        r[i + 1].index
      ) : n.substring((m ?? 0) + e.length)
    ] }, `${l == null ? void 0 : l.text}${i}`)
  ));
};
export {
  k as Hyperlink,
  v as MailToHyperlink,
  $ as formatMarkDownLinks
};
//# sourceMappingURL=index.js.map
